<template>

<v-dialog v-model="dialog" width="90vw">
  <v-card>
    <p class=".title ma-2">Ledger mutations - Host: {{hctrHcgm.eign_code}} {{hctrHcgm.eign_naam}}</p>
    <v-form ref="showHctrHcgm">
       
       <v-simple-table dense>
                    <template v-slot:default>
                      <thead> 
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Deb</span></td>
                            <td align="right"><span class="10px font-weight-light">Cred</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>   
                        </thead>
                        

                                               
                        <tbody v-for="(hctrRecord,k1) in hctrHcgm.hctr" :key="k1">
                          <tr>
                            <td> {{hctrRecord.hctr_dt}} </td>
                            <td>{{hctrRecord.fctitaal_oms}}</td>
                            <td></td>
                            <td></td>
                            <td align="right">{{hctrRecord.hctr_line }}</td>
                            <td align="right">{{hctrRecord.hctr_payment }}</td>
                          </tr>
                          <tr v-for="(hcgmRecord,k2) in hctrRecord.hcgm" :key="k2">
                            <td><span class="mx-2">{{hcgmRecord.hcgm_datum}}</span></td>
                            <td><span class="mx-3">{{hcgmRecord.gbrk_nr}} - {{hcgmRecord.gbrk_oms}}</span></td>
                            <td align="right">{{hcgmRecord.hcgm_deb}}</td>
                            <td align="right">{{hcgmRecord.hcgm_cred}}</td>
                          </tr>  
                        </tbody>    

                    </template>  
                  </v-simple-table>
       

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hoct_encrid: null,
      hctrHcgm: {}
    }
  },
  methods: {
    open(hoct_encrid, hcgm_boek_verblijf) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hoct_encrid = hoct_encrid;
      this.$axios
        .post("ares/json/ares/huov/hctr/hcgm/getHctrHcgm.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHctrHcgm"
          },
          getHctrHcgm: {
            hoct_encrid: hoct_encrid,
            hcgm_boek_verblijf: hcgm_boek_verblijf
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hctrHcgm = res.data.getHctrHcgm;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

